if (document.querySelector('.wp-block-gallery.has-nested-images')) {
  let figureTags = document.querySelectorAll(
    '.wp-block-gallery.has-nested-images figure'
  )

  figureTags.forEach((element, index) => {
    let image = element.firstChild

    let parentDiv = document.createElement('div')
    parentDiv.classList.add('h-full')

    let aTag = document.createElement('a')
    aTag.classList.add('glightbox', 'image')
    aTag.setAttribute('href', image.src)

    parentDiv.appendChild(aTag).appendChild(image)
    element.appendChild(parentDiv)
  })
}
document.addEventListener('DOMContentLoaded', function () {
  const galleries = document.querySelectorAll('.wp-block-gallery')
  galleries.forEach((gallery) => {
    const images = gallery.querySelectorAll('.wp-block-image')
    if (images.length % 2 !== 0 && images.length > 0) {
      images[images.length - 1].classList.add('lg:col-span-2')
    }
  })
})
